module.exports = __webpack_public_path__ + "static/media/background-sternax.6bbea89a.jpg";